import React, { useEffect, useState }  from 'react';
import axios from "axios";
import Header from "../Header/Header";
import { Layout } from "../Layout/Layout";
import { Link, useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { IconButton, MenuItem, TextField, Tooltip } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import SearchableDropdown from "../Common/SearchableDropdown";

import { useFormik } from 'formik';
import * as yup from 'yup';

const checkQuestionExists = async (name,competencyId) => {
    let response = await axios.get(`/api/questions/isduplicate?name=${name}&competencyId=${competencyId}`)
    let result = response.data;
    if(result.success && result.exists === false){
        return true
    }
    else {
         return false
    }    
};

const normalizeString = (value) => {
    if (!value) return '';
    return value
        .trim()                
        .replace(/\s+/g, ' ');
};

export default function AddQuestion() {
    const { competencyId, userId } = useParams();
    const navigate = useNavigate();
    const [compentency, setCompentency] = useState([]);
    const [questionTypes, setQuestionTypes] = useState([]);

    useEffect(() => {          
        formik.setFieldValue('competencyId', competencyId)     
        formik.setFieldValue('userId', userId)     
        getQuestionTypes();
        // getList();
        getCompetency();
    }, []);

    const getQuestionTypes = async() => {
        await axios.get('/api/questions/types')
        .then(function (response) {
            let result = response.data;
            if(result.success){
                setQuestionTypes(result.data)
            }
            else {
                // setIsError(true);
            }
        })
    }
    const getCompetency = async () => {
        await axios.get(`api/singleCompetency?id=${competencyId}`).then(function (response) {
            let result = response.data;
            if(result.success){
                setCompentency(result.data)  
            }
            else {
                // setIsError(true);
            }
        })
    }
    // const validationSchema = yup.object({
    //     competencyId: yup.string().required('Competency is required'),
    //     questions: yup.array().of(
    //         yup.object({
    //             questionTypeId: yup.string().required('Question Type is required'),
    //             name: yup.string().required('Name is required')
    //                 .test('is-unique', 'Duplicate names are not allowed', function (value) {
    //                     const normalizedValue = normalizeString(value)
    //                     const questionsArray = formik.values.questions;
    //                     const isDuplicate = questionsArray.filter(question => question.name === normalizedValue).length > 1;
    //                     return !isDuplicate;
    //                 })
    //                 .test('name check', 'Question already exists', value => checkQuestionExists(normalizeString(value),competencyId))
    //         })
    //     ),
    // });

    const validationSchema = yup.object({
        competencyId: yup.string().required('Competency is required'),

        questions: yup.array().of(
            yup.object({
                questionTypeId: yup
                    .string()
                    .required('Question Type is required'),

                name: yup
                    .string()
                    .required('Name is required')

                    // Duplicate validation - all question types
                    .test(
                        'is-unique',
                        'Duplicate names are not allowed',
                        function (value) {
                            const normalizedValue = normalizeString(value);

                            const questionsArray = formik.values.questions;

                            const isDuplicate = questionsArray.filter(
                                question =>
                                    normalizeString(question.name).toLowerCase() ===
                                    normalizedValue.toLowerCase()
                            ).length > 1;

                            return !isDuplicate;
                        }
                    )

                    // Special base-question validation - ONLY type 1
                    .test(
                        'valid-base-question',
                        function (value) {
                            const questionTypeId =
                                this.parent?.questionTypeId;

                            // Only apply this validation for Question Type 1
                            if (String(questionTypeId) !== '1') {
                                return true;
                            }

                            if (!value) {
                                return true;
                            }

                            const normalizedValue =
                                normalizeString(value);

                            // Don't allow trailing punctuation
                            if (/[.!?]+$/.test(normalizedValue)) {
                                return this.createError({
                                    message:
                                        'Do not add punctuation at the end'
                                });
                            }

                            // Don't allow question format
                            const questionPattern =
                                /^(how|what|why|when|where|who|does|do|did|is|are|was|were|can|could|would|should|will|has|have|had)\b/i;

                            if (questionPattern.test(normalizedValue)) {
                                return this.createError({
                                    message:
                                        'Enter the base action, not a complete question'
                                });
                            }

                            // Don't allow subject-based statements
                            const statementPattern =
                                /^(the|this|that|he|she|they|we|you|an|a)\b/i;

                            if (statementPattern.test(normalizedValue)) {
                                return this.createError({
                                    message:
                                        'Enter the action only, e.g. "Communicate clearly with team members"'
                                });
                            }

                            return true;
                        }
                    )

                    // Existing DB duplicate validation - all question types
                    .test(
                        'name-check',
                        'Question already exists',
                        function (value) {
                            return checkQuestionExists(
                                normalizeString(value),
                                competencyId
                            );
                        }
                    )
            })
        )
    });

    const initialValues = {
        userId: userId,
        competencyId: '',
        questions: [
          {
            questionTypeId: '',
            name: ''
          }
        ]
    };

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: values => {
            handleSubmit(values);
        }
    });
    
    const handleSubmit = (values) =>{
        console.log(values);
            const cleanedValues = {
                ...values,
                questions: values.questions.map(q => ({
                    ...q,
                    name: normalizeString(q.name)
                }))
            };
        // return false;
            axios.post(`api/questions/create`, cleanedValues).then(res => {
                if(res.data.success){
                    Swal.fire(res.data.message, '', 'success').then(result => {                        
                        navigate(-1);
                    })                
                } 
                else{
                    Swal.fire(res.data.message, '', 'error')
                }
            }).catch((error) => {
                Swal.fire(error.response.data.message, '', 'error')
            });      
    }

    const handleAddMoreQuestions = () => {
        const newQuestion = {
          questionTypeId: '',
          name: ''
        };
        formik.setFieldValue('questions', [...formik.values.questions, newQuestion]);
    };

    const handleRemoveQuestion = (questionIndex) => {
        const newQuestions = [...formik.values.questions];
        newQuestions.splice(questionIndex, 1);
        formik.setFieldValue('questions', newQuestions);
    };

    const handleQuestionTypeChange = (e, questionIndex) => {
        const newQuestions = [...formik.values.questions];
        newQuestions[questionIndex].questionTypeId = e.target.value;
        formik.setFieldValue('questions', newQuestions);
      };
      
    const handleQuestionNameChange = async (e, questionIndex) => {
        const newQuestions = [...formik.values.questions];
        newQuestions[questionIndex].name = e.target.value;
        formik.setFieldValue('questions', newQuestions);
    };
    return(
        <Layout>
            <Header pageTitle={'Add Question'} />
            <div className="container-xxl flex-grow-1 container-p-y">
                <div className="">
                    <div className="card-header">
                        <div className="row align-items-center">                    
                            <div className="col-lg-10 col-6 mb-Rg-3">
                                <h3 className="fw-bold mb-0">Add Questions for {compentency && compentency.name ? compentency.name : ''}</h3>
                            </div>                                             
                            <div className="col-lg-2 col-6 mb-Rg-3">
                                <p  className="btn btn-primary w-100" onClick={() => navigate(-1)} ><span className="tf-icons bx left-arrow"></span>&nbsp; Go Back </p>                             
                                {/* <Link to='/competencies' type="button" className="btn btn-primary w-100">
                                    <span className="tf-icons bx left-arrow"></span>&nbsp; Go Back
                                </Link> */}
                            </div>                           
                        </div>                       
                    </div>
                    <div className="container-xxl flex-grow-1 container-p-y">
                       <div className="row">
                            <div className="col-lg-12 col-12 order-1">
                                <div className="card">
                                    <div className="card-body">
                                    <form autoComplete="off" onSubmit={formik.handleSubmit}> 
                                    {
                                    formik.values.questions.map((question, qkey) => (
                                        <>
                                            <div className="row" key={qkey}>
                                                <div className="col-md-4">
                                                    <div className="mb-3">
                                                        <TextField
                                                            fullWidth
                                                            select
                                                            size='small'
                                                            label='Question Type'
                                                            id='questionTypeId'
                                                            value={question.questionTypeId}
                                                            onChange={(e) => handleQuestionTypeChange(e, qkey)}
                                                        >
                                                            <MenuItem value={""}>Please Select</MenuItem>
                                                            {
                                                                questionTypes.length > 0 ? 
                                                                questionTypes.map(questionType => (
                                                                    <MenuItem key={questionType.id} value={questionType.id}>{questionType.name}</MenuItem>
                                                                ))
                                                                : ''
                                                            }
                                                        </TextField>
                                                        {formik.touched.questions && formik.touched.questions[qkey]?.questionTypeId && Boolean(formik.errors.questions?.[qkey]?.questionTypeId) && (<div className="text-danger">{formik.errors.questions[qkey]?.questionTypeId}</div>) }
                                                    </div> 
                                                    
                                                    {/* {formik.touched.questions && formik.touched.questions[qkey] && formik.touched.questions[qkey]?.questionTypeId && formik.errors.questions[qkey]?.questionTypeId && (<div className="text-danger">{formik.errors.questions[qkey]?.questionTypeId}</div>)} */}
                                                </div>
                                                <div className="col-md-7">
                                                    <div className="mb-3">                                              
                                                        <input className="form-control" type="text" placeholder="Question"
                                                         id={`questions[${qkey}].name`}// Adjusted the id attribute
                                                         value={question.name}
                                                         onChange={(e) => handleQuestionNameChange(e, qkey)}/>
                                                         {formik.touched.questions && formik.touched.questions[qkey]?.name && Boolean(formik.errors.questions?.[qkey]?.name) && (<div className="text-danger">{formik.errors.questions[qkey]?.name}</div>)}
                                                    </div>
                                                    
                                                    {/* {formik.touched.questions && formik.touched.questions[qkey] && formik.touched.questions[qkey]?.name && formik.errors.questions[qkey]?.name && (<div className="text-danger">{formik.errors.questions[qkey]?.name}</div>)} */}
                                                </div>
                                                {
                                                qkey > 0 ?
                                                <div className="col-md-1">
                                                    <div className="mt-2">                                              
                                                        <Tooltip  onClick={() => handleRemoveQuestion(qkey)} title="Delete" size='small' className='icon icon-sm icon-primary'>
                                                            <IconButton>
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                                : ''
                                            } 

                                            </div>
                                        </>
                                    ))
                                    }
                                        <div className="row">
                                            <div className="col-lg-3 mt-1">
                                                <div className="mb-3">
                                                    <h5 className="fw-bold clr-theme cursor-pointer" onClick={handleAddMoreQuestions}>Add Question</h5>
                                                </div>
                                            </div>  
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-2 mt-1">
                                                <div className="mb-3">
                                                    <button type='submit' className="btn btn-primary w-100"> Save</button>
                                                </div>
                                            </div>  
                                        </div> 
                                    </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>           
        </Layout>
    )
}